import DataStructure from "./DataStructure";

// One chunk of the Document Library name index, libraryIndex/{tier}-{chunk}.
// Cloud Functions write it (functions/libraryIndex.js); the client only
// reads it, through src/util/libraryIndex.js, which turns the one-letter
// entry keys into readable entries. See functions/libraryIndexUtil.js for
// the entry format.
export default class LibraryIndexChunk extends DataStructure {
  constructor(id, data = {}) {
    super({
      tier: data.tier || "",
      entries: data.entries || {},
    });
    this.id = id || null;
  }

  static getPath(id) {
    return id ? `libraryIndex/${id}` : "libraryIndex";
  }

  static fromFirestore(snapshot, options) {
    return new LibraryIndexChunk(snapshot.id, snapshot.data(options));
  }

  static toFirestore() {
    throw new Error("The library index is written by Cloud Functions only");
  }
}
